import { risapi, getAxiosConfig } from './risapi';

export const getOpeningBalances = async (callback) => {
    try {
        const response = await risapi.get('/api/opening-balances', getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

export const saveOpeningBalances = async (balances, callback) => {
    try {
        const payload = { balances: balances };
        const response = await risapi.post('/api/opening-balances', payload, getAxiosConfig());
        callback(response.data);
    } catch (error) {
        callback(error);
    }
};

